import DealStageType from "@mapmycustomers/shared/enum/DealStageType";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import displayOrderComparator from "./displayOrderComparator";

const typeOrderMap: Record<DealStageType, number> = {
  [DealStageType.DEFAULT]: 0,
  [DealStageType.LOST]: 2,
  [DealStageType.WON]: 1,
};

// order by type according to display order, but still fallback to the older
// stage type order in case display order for both stages is null (or 0)
const stageComparator = (a: Stage, b: Stage) => {
  if (!a.displayOrder && !b.displayOrder) {
    return typeOrderMap[a.type] - typeOrderMap[b.type];
  }

  return displayOrderComparator(a, b);
};

export default stageComparator;
